import axios from "axios";
import axiosTokenService from "./axiosTokenService";
import { Uploadtokenurl, downloadUrl, downloadfileurl, fileUpload_url_live, final_url, housing_uploadtoken_dev, housingtokenurl, upload_url } from "./Configuration";
import axiosWithOutToken from "../Components/axiosWithOutToken";

class KpiService {
  sendOtp(params) {
    return axios.post(final_url + "api/sendotp", params);
  }

  getKpiIndicatorlist(params) {
    return axiosTokenService.post(
      final_url + "deptWiseKpiIndicatorslist",
      params,
    );
  }
  getDeptId(params) {
    return axiosTokenService.post(final_url + "getDeptID", params);
  }
  getDdolist(params) {
    return axiosTokenService.post(final_url + "DDOlist", params);
  }
  getOrglist(params) {
    return axiosTokenService.post(final_url + "Organizationlist", params);
  }
  getEmplist(params) {
    return axiosWithOutToken.post(
      final_url + "api/getAllEmployeesInOrgUnit",
      params,
    );
  }
  saveDistEmpMap(params) {
    return axiosTokenService.post(final_url + "SaveDistToEmpMapping", params);
  }
  getDistEmpMap(params) {
    return axiosTokenService.post(
      final_url + "getDistToEmpMappingDetails",
      params,
    );
  }

  getMandalDDOlist(params) {
    return axiosTokenService.post(final_url + "MandalDDOlist", params);
  }
  SaveMandalToEmpMapping(params) {
    return axiosTokenService.post(final_url + "SaveMandalToEmpMapping", params);
  }

  getMandalToEmpMappingDetails(params) {
    return axiosTokenService.post(
      final_url + "getMandalToEmpMappingDetails",
      params,
    );
  }

  //Corporatedistlevel
  corpsaveDistEmpMap(params) {
    return axiosTokenService.post(
      final_url + "corpLevelDistrictMapOfficers",
      params,
    );
  }
  corpgetDistEmpMap(params) {
    return axiosTokenService.post(
      final_url + "getCorpDistToEmpMappingDetails",
      params,
    );
  }
  corpgetEmpMappedDetails(params) {
    return axiosTokenService.post(final_url + "getEmpMappedDetails", params);
  }
  //Corporatemandallevel
  corpLevelDistToMandalMapOfficers(params) {
    return axiosTokenService.post(
      final_url + "corpLevelDistToMandalMapOfficers",
      params,
    );
  }
  getCorpDistToMandalEmpMappingDetails(params) {
    return axiosTokenService.post(
      final_url + "getCorpDistToMandalEmpMappingDetails",
      params,
    );
  }
  //Departmentwise Officer Details Report
  getDeptWiseMappedOfficersDetails(params) {
    return axiosTokenService.post(
      final_url + "getDeptWiseMappedOfficersDetails",
      params,
    );
  }

  getdeptwiseempdata(params) {
    return axiosTokenService.post(final_url + "getdeptwiseempdata", params);
  }

  //KpiIndicatoryentrymandal
  getPeriodicitylist(params) {
    return axiosTokenService.post(final_url + "kpiperiodicmaster", params);
  }
  KpiperiodicYears(params) {
    return axiosTokenService.post(
      final_url + "kpiperiodicityMasterYears",
      params,
    );
  }
  kpiperiodicityMasterFutureDatesExtension(params) {
    return axiosTokenService.post(
      final_url + "kpiperiodicityMasterFutureDatesExtension",
      params,
    );
  }
  Kpientrydata(params) {
    return axiosTokenService.post(
      final_url + "mandalLevelIndicatorsDataEntry",
      params,
    );
  }
  SaveKpiMandalentry(params) {
    return axiosTokenService.post(
      final_url + "mandalLevelIndicatorsDataEntrySave",
      params,
    );
  }

  CpoTableData(params) {
    return axiosTokenService.post(
      final_url + "mandalWiseIndicatorsEntryDataStatus",
      params,
    );
  }
  //distlevel
  Kpientrydatadistlevel(params) {
    return axiosTokenService.post(
      final_url + "districtLevelIndicatorsDataEntry",
      params,
    );
  }
  SaveKpiMandalentrydistlevel(params) {
    return axiosTokenService.post(
      final_url + "districtLevelIndicatorsDataEntrySave",
      params,
    );
  }
  HodTableData(params) {
    return axiosTokenService.post(
      final_url + "districtWiseIndicatorsEntryDataStatus",
      params,
    );
  }

  //hodlevel

  Kpientrydatahodlevel(params) {
    return axiosTokenService.post(
      final_url + "hodLevelIndicatorsDataEntry",
      params,
    );
  }
  SaveKpiMandalentryhodlevel(params) {
    return axiosTokenService.post(
      final_url + "hodLevelIndicatorsDataEntrySave",
      params,
    );
  }
  //Kpi indicator Report
  getKpiIndicaterReportDetails(params) {
    return axiosTokenService.post(
      final_url + "mandalLevelKpiIndicaterEntryReport",
      params,
    );
  }
  getKpiIndicaterReportCount(params) {
    return axiosTokenService.post(
      final_url + "getKpiIndicaterReportCount",
      params,
    );
  }
  getKpiIndicaterSavedList(params) {
    return axiosTokenService.post(
      final_url + "getKpiIndicaterSavedList",
      params,
    );
  }

  //TargetsEntry
  getTargetEntrylist(params) {
    return axiosTokenService.post(final_url + "getHodkpiIndicators", params);
  }
  SaveTargetEntrylist(params) {
    return axiosTokenService.post(
      final_url + "hodkpiIndicatorTargetSave",
      params,
    );
  }

  // query explorer
  QueryExplorer(params) {
    return axiosTokenService.post(final_url + "queryExplorer", params);
  }

  // kpi Dashboard
  dashboardStatus(params) {
    return axiosTokenService.post(final_url + "dashboardStatus", params);
  }
  //GsdpEstimates
  gsdpestimatesSector(params) {
    return axiosTokenService.post(final_url + "getGSDPSectors", params);
  }
  gsdpestimatesSave(params) {
    return axiosTokenService.post(final_url + "saveGSDPSectors", params);
  }
  //gSDPeSTIMATESREPORT
  gsdpestimatesReport(params) {
    return axiosTokenService.post(final_url + "gsdpEstimatesReport", params);
  }
  gsdpContributionReport(params) {
    return axiosTokenService.post(final_url + "gsdpContributionReport", params);
  }
  gsdpgrowthReport(params) {
    return axiosTokenService.post(final_url + "gsdpGrowthReport", params);
  }
  //getAssemblies
  getAssemblies(params) {
    return axiosTokenService.post(final_url + "getAssemblies", params);
  }

  getAssemblyMandals(params) {
    return axiosTokenService.post(final_url + "getAssemblyMandals", params);
  }

  getgsdpAssemblyEstimatesReport(params) {
    return axiosTokenService.post(
      final_url + "gsdpAssemblyEstimatesReport",
      params,
    );
  }
  getgsdpAssemblyDistrictReport(params) {
    return axiosTokenService.post(
      final_url + "gsdpAssemblyDistrictReport",
      params,
    );
  }
  getgsdpAssemblyGrowthReport(params) {
    return axiosTokenService.post(
      final_url + "gsdpAssemblyGrowthReport",
      params,
    );
  }

  getusersList(params) {
    return axiosTokenService.post(final_url + "usersList", params);
  }
  getemployees(params) {
    return axiosWithOutToken.post(final_url + "api/employees", params);
  }
  getDesLevelMandalMappedData(params) {
    return axiosTokenService.post(
      final_url + "desLevelMandalMappOfficers",
      params,
    );
  }
  //hod
  getusersDistList(params) {
    return axiosTokenService.post(final_url + "usersDistList", params);
  }
  getHodDesLevelDistrictMapOfficers(params) {
    return axiosTokenService.post(
      final_url + "hodDesLevelDistrictMapOfficers",
      params,
    );
  }

  //hod dist mandal
  getMandalsUsersList(params) {
    return axiosTokenService.post(final_url + "getMandalsUsersList", params);
  }
  getHodLevelMandalMappOfficers(params) {
    return axiosTokenService.post(
      final_url + "hodLevelMandalMappOfficers",
      params,
    );
  }

  // Kpi indicator district report
  getdistrictLevelKpiIndicaterEntryReport(params) {
    return axiosTokenService.post(
      final_url + "districtLevelKpiIndicaterEntryReport",
      params,
    );
  }
  // Kpi indicator hod report
  getdistrictWiseIndicatorsEntryDataCount(params) {
    return axiosTokenService.post(
      final_url + "districtWiseIndicatorsEntryDataCount",
      params,
    );
  }
  gethodLevelKpiIndicaterEntryReport(params) {
    return axiosTokenService.post(
      final_url + "hodLevelKpiIndicaterEntryReport",
      params,
    );
  }

  //progress reports kpi
  getmandalLevelKpiIndicaterEntryProgressReport(params) {
    return axiosTokenService.post(
      final_url + "mandalLevelKpiIndicaterEntryProgressReport",
      params,
    );
  }
  getdistrictLevelKpiIndicaterEntryProgressReport(params) {
    return axiosTokenService.post(
      final_url + "districtLevelKpiIndicaterEntryProgressReport",
      params,
    );
  }
  gethodLevelKpiIndicaterEntryProgressReport(params) {
    return axiosTokenService.post(
      final_url + "hodLevelKpiIndicaterEntryProgressReport",
      params,
    );
  }

  //SectraiatTargetsEntry
  getSeckpiIndicators(params) {
    return axiosTokenService.post(final_url + "getSeckpiIndicators", params);
  }
  SectSaveTargetEntrylist(params) {
    return axiosTokenService.post(
      final_url + "seckpiIndicatorTargetSave",
      params,
    );
  }

  //sectkpiInDICATORENTRY
  getsecretariatLevelIndicatorsDataEntry(params) {
    return axiosTokenService.post(
      final_url + "secretariatLevelIndicatorsDataEntry",
      params,
    );
  }

  secretariatLevelIndicatorsDataEntrySave(params) {
    return axiosTokenService.post(
      final_url + "secretariatLevelIndicatorsDataEntrySave",
      params,
    );
  }

  secretariatLevelKpiIndicaterEntryReport(params) {
    return axiosTokenService.post(
      final_url + "secretariatLevelKpiIndicaterEntryReport",
      params,
    );
  }
  secretariatLevelKpiIndicaterEntryProgressReport(params) {
    return axiosTokenService.post(
      final_url + "secretariatLevelKpiIndicaterEntryProgressReport",
      params,
    );
  }
  getsecretariatlist(params) {
    return axiosTokenService.post(final_url + "secretariatList", params);
  }

  //New Indicator Entry
  secretariatMasterData(params) {
    return axiosTokenService.post(final_url + "secretariatMasterData", params);
  }
  applicableSecMasterTargetsHods(params) {
    return axiosTokenService.post(
      final_url + "applicableSecMasterTargetsHods",
      params,
    );
  }

  hodMasterData(params) {
    return axiosTokenService.post(final_url + "hodMasterData", params);
  }
  periodicitymaster(params) {
    return axiosTokenService.post(final_url + "periodicitymaster", params);
  }
  unitMasterData(params) {
    return axiosTokenService.post(final_url + "unitMasterData", params);
  }
  savedIndicatorsList(params) {
    return axiosTokenService.post(final_url + "savedIndicatorsList", params);
  }
  newIndicatorsAdd(params) {
    return axiosTokenService.post(final_url + "newIndicatorsAdd", params);
  }

  //TargetsReport
  getMandalTargetreport(params) {
    return axiosTokenService.post(final_url + "mandalWiseTargetReport", params);
  }

  getSecTargetreport(params) {
    return axiosTokenService.post(final_url + "secWiseTargetReport", params);
  }

  getdistWiseTargetReport(params) {
    return axiosTokenService.post(
      final_url + "hodDistrictWiseTargetReport",
      params,
    );
  }

  gethodWiseTargetReport(params) {
    return axiosTokenService.post(final_url + "hodWiseTargetReport", params);
  }
  mandalLevelIndicatorsDataEntrySave(params) {
    return axiosTokenService.post(
      final_url + "mandalLevelIndicatorsDataEntrySave",
      params,
    );
  }
  districtLevelIndicatorsDataEntrySave(params) {
    return axiosTokenService.post(
      final_url + "districtLevelIndicatorsDataEntrySave",
      params,
    );
  }
  getmasterKpiIndicatorslist(params) {
    return axios.post(final_url + "masterKpiIndicatorslist", params);
  }
  getDeptartmentsWithoutToken(params) {
    return axios.post(final_url + "getDeptartmentsWithoutToken", params);
  }
  secretariatListWithoutToken() {
    return axios.get(final_url + "secretariatListWithoutToken");
  }

  getperiodicityStatusForAchievementsEntry(params) {
    return axiosTokenService.post(
      final_url + "periodicityStatusForAchievementsEntry",
      params,
    );
  }

  getupdateEmpMappingDetails(params) {
    return axiosTokenService.post(
      final_url + "getupdateEmpMappingDetails",
      params,
    );
  }
  updateEmpMappingDetails(params) {
    return axiosTokenService.post(
      final_url + "updateEmpMappingDetails",
      params,
    );
  }
  hrmsempdata(params) {
    return axios.post(final_url + "api/hrmsempdata", params);
  }

  getMappedOfficersCount(params) {
    return axiosTokenService.post(final_url + "mappedOfficersCount", params);
  }

  gettargetentryCount(params) {
    return axiosTokenService.post(final_url + "targetCountReport", params);
  }

  getindicatorsList(params) {
    return axiosTokenService.post(final_url + "kpiindicatorsList", params);
  }

  getindicatorswisecountList(params) {
    return axiosTokenService.post(
      final_url + "kpiindicatorsCountReport",
      params,
    );
  }

  ddosData(params) {
    return axiosTokenService.post(final_url + "fetchddos", params);
  }

  getdddocodes(params) {
    return axiosTokenService.post(final_url + "getdddocodes", params);
  }

  SaveNewddos(params) {
    return axiosTokenService.post(final_url + "savenewddosall", params);
  }

  fetchorgsData(params) {
    return axiosTokenService.post(final_url + "fetchorgs", params);
  }

  SaveNewOrgs(params) {
    return axiosTokenService.post(final_url + "saveneworgsall", params);
  }

  fetchPositionList(params) {
    return axiosTokenService.post(final_url + "fetchpositionlist", params);
  }

  SaveNewEmployee(params) {
    return axiosTokenService.post(final_url + "savenewemployee", params);
  }
  updatecorp(params) {
    return axiosTokenService.post(
      final_url + "updateCorpEmpMappingDetails",
      params,
    );
  }
  gethrmsempdata(params) {
    return axiosTokenService.post(final_url + "hrmsempdata", params);
  }
  populationReport(params) {
    return axiosTokenService.post(final_url + "populationReport", params);
  }
  deleteEmpMappingDetails(params) {
    return axiosTokenService.post(
      final_url + "deleteEmpMappingDetails",
      params,
    );
  }

  updatealternatemobile(params) {
    return axiosTokenService.put(final_url + "updatealternatemobile", params);
  }

  resetuserpassword(params) {
    return axiosTokenService.put(final_url + "resetuserpassword", params);
  }
  userchangepassword(params) {
    return axiosTokenService.post(final_url + "userchangepassword", params);
  }
  searchuser(params) {
    return axiosTokenService.post(final_url + "searchuser", params);
  }
  editEmpMobileNo(params) {
    return axiosTokenService.post(final_url + "editEmpMobileNo", params);
  }
  secretariatbaseDeptList(params) {
    return axiosTokenService.post(final_url + "deptwiseSecList", params);
  }

  getrolecategory() {
    return axiosTokenService.get(final_url + "getrolecategory");
  }
  kpisAbstractReport(params) {
    return axiosTokenService.post(final_url + "kpisAbstractReport", params);
  }
  kpiIndicatortargetsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "kpiIndicatortargetsUnfreeze",
      params,
    );
  }
  getulbList(params) {
    return axiosTokenService.post(final_url + "getulbList", params);
  }
  deptDistMapping(params) {
    return axiosTokenService.post(final_url + "deptDistMandalMapping", params);
  }
  getDistMandalmappedList(params) {
    return axiosTokenService.post(
      final_url + "getDistMandalmappedList",
      params,
    );
  }
  kpisAchievementReport(params) {
    return axiosTokenService.post(final_url + "kpisAchievementReport", params);
  }
  kpisAchievementIndicatorReport(params) {
    return axiosTokenService.post(
      final_url + "kpisAchievementIndicatorReport",
      params,
    );
  }

  kpisAchievementAbstractReport(params) {
    return axiosTokenService.post(
      final_url + "kpisAchievementAbstractReport",
      params,
    );
  }

  acheivementsTargetsEmpMappingReport(params) {
    return axiosTokenService.post(
      final_url + "acheivementsTargetsEmpMappingReport",
      params,
    );
  }
  indicatorWiseTargetsAchievementsReport(params) {
    return axiosTokenService.post(
      final_url + "indicatorWiseTargetsAchievementsReport",
      params,
    );
  }

  periodicityStatus(params) {
    return axiosTokenService.post(final_url + "periodicityStatus", params);
  }

  indicatorWiseTargetsAchievementsProgressReport(params) {
    return axiosTokenService.post(
      final_url + "indicatorWiseTargetsAchievementsProgressReport",
      params,
    );
  }
  achievementsUnfreeze(params) {
    return axiosTokenService.post(final_url + "achievementsUnfreeze", params);
  }
  districtlevelachievementsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "districtlevelachievementsUnfreeze",
      params,
    );
  }
  hodlevelachievementsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "hodlevelachievementsUnfreeze",
      params,
    );
  }
  seclevelachievementsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "seclevelachievementsUnfreeze",
      params,
    );
  }
  mandalachievementsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "mandalforwardedachievementsUnfreeze",
      params,
    );
  }
  districtforwardedachievementsUnfreeze(params) {
    return axiosTokenService.post(
      final_url + "districtforwardedachievementsUnfreeze",
      params,
    );
  }

  //PerformanceDashboard
  dashboardKpiScoresGardes(params) {
    return axiosTokenService.post(
      final_url + "dashboardKpiScoresGardes",
      params,
    );
  }

  dashboardSecBasedHodList(params) {
    return axiosTokenService.post(
      final_url + "dashboardSecBasedHodList",
      params,
    );
  }

  dashboardKpiData(params) {
    return axiosTokenService.post(final_url + "dashboardKpiData", params);
  }
  dashboardDistrictWiseData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseData",
      params,
    );
  }
  reloadRoleServices() {
    return axios.post(final_url + "api/reloadRoleServices");
  }
  roleServicesByRoleId(role) {
    return axios.get(final_url + `api/roleServicesByRoleId?roleId=${role}`);
  }
  rolessmaster() {
    return axios.get(final_url + "api/rolessmaster");
  }
  targetsAchvmtsPercentVariationReport(params) {
    return axiosTokenService.post(
      final_url + "targetsAchvmtsPercentVariationReport",
      params,
    );
  }
  AbstractReport(params) {
    return axiosTokenService.post(
      final_url + "districtkpiscoresandgrades",
      params,
    );
  }
  AbstractReportdrilldown(params) {
    return axiosTokenService.post(
      final_url + "districtkpiscoresandgradescounts",
      params,
    );
  }

  // Dashboard related apis by jeevan anna

  dashboardTopScoreDistAndMandal(params) {
    return axiosTokenService.post(
      final_url + "dashboardTopScoreDistAndMandal",
      params,
    );
  }

  dashboardMandalWiseIndicatorDataTab(params) {
    return axiosTokenService.post(
      final_url + "dashboardMandalWiseIndicatorDataTab",
      params,
    );
  }

  dashboardDistrictWiseIndicatorData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseIndicatorData",
      params,
    );
  }
  MandalCodeFromMandalName(params) {
    return axiosTokenService.post(
      final_url + "MandalCodeFromMandalName",
      params,
    );
  }

  dashboardKpiScoresGardesConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "dashboardKpiScoresGardesConstituencyWise",
      params,
    );
  }
  dashboardMandalDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "dashboardMandalDataConstituencyWise",
      params,
    );
  }
  dashboardKpiDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "dashboardKpiDataConstituencyWise",
      params,
    );
  }
  dashboardDistrictDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictDataConstituencyWise",
      params,
    );
  }
  dashboardIndicatorDrillDownConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "dashboardIndicatorDrillDownConstituencyWise",
      params,
    );
  }
  dashboardKpiScoresHodGrades(params) {
    return axiosTokenService.post(
      final_url + "dashboardKpiScoresHodGrades",
      params,
    );
  }

  // dashboardMandalWiseIndicatorData(params) {
  //   return axiosTokenService.post(final_url + "dashboardMandalWiseIndicatorData", params)
  // }

  // dashboardDepartmentDrilldown(params) {
  //   return axiosTokenService.post(final_url + "dashboardDepartmentDrilldown", params)
  // }
  // dashboardIndicatorWiseDrilldown(params) {
  //   return axiosTokenService.post(final_url + "dashboardIndicatorWiseDrilldown", params)
  // }

  //  SDG Dashboard
  SDGdashboardKpiScoresGardes(params) {
    return axiosTokenService.post(
      final_url + "SDGdashboardKpiScoresGardes",
      params,
    );
  }

  SDGdashboardKpiData(params) {
    return axiosTokenService.post(final_url + "SDGdashboardKpiData", params);
  }
  indicatorWiseProgressReport(params) {
    return axiosTokenService.post(
      final_url + "indicatorWiseProgressReport",
      params,
    );
  }
  dashboardDeptWiseSDGIndicatorDataTab(params) {
    return axiosTokenService.post(
      final_url + "dashboardDeptWiseSDGIndicatorDataTab",
      params,
    );
  }
  dashboardMandalWiseSDGIndicatorDataTab(params) {
    return axiosTokenService.post(
      final_url + "dashboardMandalWiseSDGIndicatorDataTab",
      params,
    );
  }

  dashboardDistrictWiseSDGIndicatorData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseSDGIndicatorData",
      params,
    );
  }

  dashboardDistrictWiseSDGData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseSDGData",
      params,
    );
  }

  // sdg dashboard apis for role cat id 112

  sdgDashboardKpiScoresGardesConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "sdgDashboardKpiScoresGardesConstituencyWise",
      params,
    );
  }
  sdgDashboardKpiDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "sdgDashboardKpiDataConstituencyWise",
      params,
    );
  }
  sdgDashboardIndicatorDrillDownConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "sdgDashboardIndicatorDrillDownConstituencyWise",
      params,
    );
  }
  sdgDashboardDistrictDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "sdgDashboardDistrictDataConstituencyWise",
      params,
    );
  }
  sdgDashboardMandalDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "sdgDashboardMandalDataConstituencyWise",
      params,
    );
  }

  //  Economic Dashboard APIS

  //112 role cat id apis

  EconomicDashboardKpiScoresGardesConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EconomicDashboardKpiScoresGardesConstituencyWise",
      params,
    );
  }
  EconomicDashboardKpiDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EconomicDashboardKpiDataConstituencyWise",
      params,
    );
  }
  EcoDashboardIndicatorDrillDownConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EcoDashboardIndicatorDrillDownConstituencyWise",
      params,
    );
  }
  EconomicDashboardDistrictDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EconomicDashboardDistrictDataConstituencyWise",
      params,
    );
  }
  EconomicDashboardMandalDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EconomicDashboardMandalDataConstituencyWise",
      params,
    );
  }

  // Ended 112 role cat id for Economic

  // Other role cat ids
  economicDashboardKpiScoresGardes(params) {
    return axiosTokenService.post(
      final_url + "economicDashboardKpiScoresGardes",
      params,
    );
  }

  economicDashboardKpiData(params) {
    return axiosTokenService.post(
      final_url + "economicDashboardKpiData",
      params,
    );
  }
  dashboardDeptWiseEconomicIndicatorDataTab(params) {
    return axiosTokenService.post(
      final_url + "dashboardDeptWiseEconomicIndicatorDataTab",
      params,
    );
  }
  dashboardDistrictWiseEconomicData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseEconomicData",
      params,
    );
  }
  dashboardDistrictWiseEconomicIndicatorData(params) {
    return axiosTokenService.post(
      final_url + "dashboardDistrictWiseEconomicIndicatorData",
      params,
    );
  }
  dashboardMandalWiseEconomicIndicatorDataTab(params) {
    return axiosTokenService.post(
      final_url + "dashboardMandalWiseEconomicIndicatorDataTab",
      params,
    );
  }

  DashboardAdminDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "DashboardAdminDataConstituencyWise",
      params,
    );
  }

  EconomicDashboardAdminDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "EconomicDashboardAdminDataConstituencyWise",
      params,
    );
  }
  SDGDashboardAdminDataConstituencyWise(params) {
    return axiosTokenService.post(
      final_url + "SDGDashboardAdminDataConstituencyWise",
      params,
    );
  }

  districtAndMandalEntryStatusReport(params) {
    return axiosTokenService.post(
      final_url + "districtAndMandalEntryStatusReport",
      params,
    );
  }

  defaulturl(params) {
    return axiosTokenService.post(final_url + "defaulturl", params);
  }
  indicatorWiseentryTypeTargetsAchievementsReport(params) {
    return axiosTokenService.post(
      final_url + "indicatorWiseTargetsAchmntsHodDistProgressReport",
      params,
    );
  }
  getConstWiseMandals(params) {
    return axiosTokenService.post(final_url + "getConstWiseMandals", params);
  }

  getConstWiseUlbs(params) {
    return axiosTokenService.post(final_url + "getConstWiseUlbs", params);
  }

  // Scores cards dashboard
  criticalDashboardScoreCard(params) {
    return axiosTokenService.post(
      final_url + "criticalDashboardScoreCard",
      params,
    );
  }
  criticalDashboardIndicators(params) {
    return axiosTokenService.post(
      final_url + "criticalDashboardIndicators",
      params,
    );
  }

  criticalDashboardBroadSectorWise(params) {
    return axiosTokenService.post(
      final_url + "criticalDashboardBroadSectorWise",
      params,
    );
  }

  criticalDashboardDeptWise(params) {
    return axiosTokenService.post(
      final_url + "criticalDashboardDeptWise",
      params,
    );
  }

  districtkpisprogressReport(params) {
    return axiosTokenService.post(
      final_url + "districtkpisprogressReport",
      params,
    );
  }

  districtkpisprogressReportpendinglist(params) {
    return axiosTokenService.post(
      final_url + "districtkpisprogressReportpendinglist",
      params,
    );
  }

  kpiValueReport(params) {
    return axiosTokenService.post(final_url + "kpiValueReport", params);
  }

  getswakpimersectordata(params) {
    return axiosTokenService.post(final_url + "getswakpimersectordata", params);
  }
  saveswakpimersectordata(params) {
    return axiosTokenService.post(
      final_url + "saveswakpimersectordata",
      params,
    );
  }

  getCriteriaSelectionData(params) {
    return axiosTokenService.post(
      final_url + "getswakpicriteriaselectiondata",
      params,
    );
  }
  getCriteriaSelectionRemarks(params) {
    return axiosTokenService.post(
      final_url + "getCriteriaSelectionDistrictIndicatorRemarksdata",
      params,
    );
  }
  getCriteriaSelectionListData(params) {
    return axiosTokenService.post(
      final_url + "getcriteriaselectionrequiredlistdata",
      params,
    );
  }
  getCriteriaSelectionSave(params) {
    return axiosTokenService.post(
      final_url + "criteriaselectiondistrictindicatorsmapping",
      params,
    );
  }

  criteriaselectiondistrictindicatorsmappingcpoLevel(params) {
    return axiosTokenService.post(
      final_url + "criteriaselectiondistrictindicatorsmappingcpoLevel",
      params,
    );
  }

  mandalMapIndicatorReport(params) {
    return axiosTokenService.post(
      final_url + "mandalMapIndicatorReport",
      params,
    );
  }

  districtMapIndicatorReport(params) {
    return axiosTokenService.post(
      final_url + "districtMapIndicatorReport",
      params,
    );
  }
  mandalIndAbstractReport(params) {
    return axiosTokenService.post(final_url + "abstractReport", params);
  }

  // criteria Performance Dashboard Score Card apis

  criteriaPerformanceDashboardScoreCard(params) {
    return axiosTokenService.post(
      final_url + "criteriaPerformanceDashboardScoreCard",
      params,
    );
  }
  criteriaPerformanceDashboardScoreCardForward(params) {
    return axiosTokenService.post(
      final_url + "criteriaPerformanceDashboardScoreCardForward",
      params,
    );
  }
  criteriaPerformanceDashboardScoreCardApprove(params) {
    return axiosTokenService.post(
      final_url + "criteriaPerformanceDashboardScoreCardApprove",
      params,
    );
  }

  criteriaPerformanceDashboardGraphScoreCard(params) {
    return axiosTokenService.post(final_url + "criteriaPerformanceDashboardGraphScoreCard", params,);
  }
  criteriaPerformanceDashboardScoreCardDistMandal(params) {
    return axiosTokenService.post(final_url + "criteriaPerformanceDashboardScoreCardDistMandal", params,);
  }

  getFilesUploadToken() { return axiosTokenService.get(Uploadtokenurl, { headers: { "Content-Type": "application/json", }, }); }

  CriteriaperformanceUploadfiles(formData, token) {
    return axios.post(
      `${upload_url}CriteriaPerformanceUploadfiles`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }



  // Changed apis for dashboards

  DashboardAllDetailsData(params) {
    return axiosTokenService.post(final_url + "dashboardAllDetailsData", params,);
  }
  monthNameFromMonthCode(params) {
    return axiosTokenService.post(final_url + "MonthNameFromMonthCode", params);
  }




  DistrcitMonthlyReport(params) {
    return axiosTokenService.post(
      final_url + "monthlyDistrictPerformReport",
      params,
    );
  }

  IndicatorwiseTargetsReport(params) {
    return axiosTokenService.post(
      final_url + "indicatorwiseTargetsReport",
      params,
    );
  }
  criteriaPerformanceDashboardScoreCardReport(params) {
    return axiosTokenService.post(final_url + "criteriaPerformanceDashboardScoreCardReport", params,);
  }
  saveNotification(formData) {
    return axiosTokenService.post(final_url + "deptNotification", formData)

  }
  //monitoring report
  economicDistrictPerformanceMonitoringReport(params) {
    return axiosTokenService.post(final_url + "economicDistrictPerformanceMonitoringReport", params,);
  }
  economicPerformanceMonitoringReport(params) {
    return axiosTokenService.post(final_url + "economicPerformanceMonitoringReport", params,);
  }



  ///scoregenration report
  kpiScoreGeneration(params) {
    return axios.post(final_url + "api/kpiscores/kpiScoreGeneration", params)
  }
  kpiEconomicScoreGeneration(params) {
    return axios.post(final_url + "api/kpiscores/kpiEconomicScoreGeneration", params)
  }
  sdgDashboardScores(params) {
    return axios.post(final_url + "sdgDashboardScores", params)
  }

  kpiFINSpclScoreGeneration(params) {
    return axios.post(final_url + "api/kpiscores/kpiFINSpclScoreGeneration", params)
  }
  criteriaPerformanceDashboardConstituencyScore(params) {
    return axios.post(final_url + "api/kpiscores/criteriaPerformanceDashboardConstituencyScore", params)
  }
  criteriaPerformanceDashboardScore(params) {
    return axios.post(final_url + "api/kpiscores/criteriaPerformanceDashboardScore", params)
  }
  criteriaPerformanceDashboardMandalScore(params) {
    return axios.post(final_url + "api/kpiscores/criteriaPerformanceDashboardMandalScore", params)
  }
  criteriaPerformanceDashboardHODScore(params) {
    return axios.post(final_url + "api/kpiscores/criteriaPerformanceDashboardHODScore", params)
  }


  // IndicatorwiseperformanceMonitoringReport apis

  indicatorPerformanceMonitoringReport(params) {
    return axiosTokenService.post(final_url + "indicatorPerformanceMonitoringReport", params)
  }






  // Downloadurl(url){
  //   return axiosTokenService.post(`https://housingapi.dev.nidhi.apcfss.in/dmsHousing/file/download?folder=Housing/SwarnaAndhra/DeptNotificationsFiles&file=${url}`)
  // }
  downloadFile(fileName, token) {
    return axios.get(
      `https://housingapi.dev.nidhi.apcfss.in/dmsHousing/file/download?folder=Housing/SwarnaAndhra/DeptNotificationsFiles&file=${encodeURIComponent(fileName)}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  downloadCriteriaFile(fileName, token) {
    return axios.get(
      downloadUrl + `CriteriaPerformanceUploadfiles&file=${encodeURIComponent(fileName)}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  downloadtoken(params) {
    return axios.post(downloadfileurl, params)
  }


  dashboardDisplaysDateWise(params) {
    return axiosTokenService.post(final_url + "dashboardDisplaysDateWise", params)
  }

  feedbackForm(params) {
    return axios.post(final_url + "api/snccsFeedbackForm", params)
  }
  sendotpfeedbackform(params) {
    return axios.post(final_url + "api/feedbackformsendotp", params)
  }

  verifyotpfeedbackform(params) {
    return axios.post(final_url + "api/feedbackformverifyotp", params)
  }
  CheckcfmsId(params) {
    return axios.post(final_url + "master/hrmsempdata", params)
  }
  FeedbackFormTopicsByUser(params) {
    return axios.post(final_url + "api/snccsFeedbackFormTopicsByUser", params)
  }
  snccsTopics() {
    return axios.get(final_url + "api/snccsTopics")
  }
  snccsSubTopics(id) {
    return axios.get(final_url + "api/snccsSubTopics/" + id)
  }
  snccsFeedbackFormDashboard(params) {
    return axiosTokenService.post(final_url + "snccsFeedbackFormDashboard", params)
  }
  //all view pdf limt
  snccsTopicswiseCfmsidsData() {
    return axios.get(final_url + "api/snccsTopicswiseCfmsidsData")
  }
  autoschedulerpdfgenerate(params) {
    return axios.post(final_url + "api/snccsFeedbackFormDashboard", params)
  }
  // NCCSFeedbackformUploadPdf(formData, token) {
  //    return axios.post( `${upload_url}NCCSFeedbackformUploadPdf`, formData, { 
  //     headers: { Authorization: `Bearer ${token}`, }, } ); 
  //   }

  NCCSFeedbackformUploadPdf(formData, token) {
    const topicId = String(formData.get("nameOfTopic"));

    const topicFolders = {
      "1": "TopicOne",
      "2": "TopicTwo",
      "3": "TopicThree",
      "4": "TopicFour",
    };

    const folderName = topicFolders[topicId] || `topic${topicId}`;

    formData.set("folderName", folderName);

    return axios.post(
      `${upload_url}NCCSFeedbackform` + `/${folderName}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
  snccsFeedbackFormpdfpathssave(params) {
    return axios.post(final_url + "api/snccsFeedbackFormpdfpathssave", params)
  }
  uploadTokenhousing(params) {
    return axios.post(housingtokenurl, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  snccsFeedbackFormEvalutionRequest(params) {
    return axiosTokenService.post(final_url + "snccsFeedbackFormEvalutionRequest", params)
  }

}


// const KpiServiceInstance = new KpiService();
export default new KpiService();
// export default new KpiService();
